import {
  RelayNetworkLayer,
} from 'react-relay-network-layer';

import { REDIRECT_URL } from '../../config';

export default function initRelayNetwork() {
  return new RelayNetworkLayer([
    next => req => {
      // eslint-disable-next-line
      req.credentials = 'same-origin';
      const resPromise = next(req);
      resPromise
        .then()
        .catch(error => {
          const errorMSG = JSON.parse(error.message).message;
          if (errorMSG === 'Not authenticated') {
            window.location.replace(REDIRECT_URL);
          }
        });

      return resPromise;
    },
  ]);
}



// WEBPACK FOOTER //
// ./src/js/RelayNetworkLayer.js